import { useMemo } from 'react';

import { translate } from '@front/i18n';

import { mapOptionsNameToOptionsLabelFormat } from './utils';

const t = translate('screens.professional_status');

export const useGbResidenceStatus = (isOptionObjectWithLabel = false) => {
  const gbResidenceStatusOptions = useMemo(
    () => [
      { name: t('.gb_residence_status.options.asylum-seeker'), value: 'asylum-seeker' },
      { name: t('.gb_residence_status.options.british'), value: 'british' },
      { name: t('.gb_residence_status.options.dependent_spouse-visa'), value: 'dependent_spouse-visa' },
      { name: t('.gb_residence_status.options.pre-settled_limited'), value: 'pre-settled_limited' },
      { name: t('.gb_residence_status.options.refugee'), value: 'refugee' },
      { name: t('.gb_residence_status.options.settled_indefinite'), value: 'settled_indefinite' },
      { name: t('.gb_residence_status.options.sponsored-visa'), value: 'sponsored-visa' },
      { name: t('.gb_residence_status.options.student'), value: 'student' },
    ],
    [],
  );

  const formattedResidenceStatusOptions = isOptionObjectWithLabel
    ? gbResidenceStatusOptions.map(mapOptionsNameToOptionsLabelFormat)
    : gbResidenceStatusOptions;

  return formattedResidenceStatusOptions;
};
